import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Grid, TextField } from '@material-ui/core'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import { fsExcludeClass } from '../../../../../utils/fsExclude'
import { useFeatureFlag } from '../../../../../redux/slices/appConfig'
import { FEATURE_FLAG } from '../../../../../constants'

const useStyles = makeStyles((theme) => ({
  userInfoForm: {
    maxWidth: '800px',
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
    '& p': {
      color: 'var(--color-primary-600)'
    }
  },
  inputLabel: {
    color: 'var(--text-color-main)',
    fontWeight: 600,
    '& span': {
      color: 'var(--text-color-main)'
    }
  }
}))

function WealthOwnerInfoDisplay ({ wealthOwner }) {
  const classes = useStyles()
  const labelProps = {
    className: classes.inputLabel
  }
  const { active: multiBrand } = useFeatureFlag(FEATURE_FLAG.MULTI_BRAND_FIRM)

  return (
    <FadeIn className={classes.userInfoForm}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <TextField
            className={fsExcludeClass}
            label='First Name'
            fullWidth
            disabled
            value={wealthOwner.firstName}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={labelProps}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            className={fsExcludeClass}
            label='Last Name'
            fullWidth
            disabled
            value={wealthOwner.lastName}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={labelProps}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            className={fsExcludeClass}
            label='Email'
            fullWidth
            disabled
            value={wealthOwner.email}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={labelProps}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            label='External User Id'
            fullWidth
            disabled
            value={wealthOwner.externalUserId}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={labelProps}
          />
        </Grid>
        {multiBrand ? (
          <Grid item xs={12} md={12}>
            <TextField
              label='Branding Config'
              fullWidth
              disabled
              value={wealthOwner.brandingConfigKey || 'Not Assigned'}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={labelProps}
            />
          </Grid>
        ) : null}
      </Grid>
    </FadeIn>
  )
}

WealthOwnerInfoDisplay.propTypes = {
  wealthOwner: PropTypes.shape({
    userId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    externalUserId: PropTypes.string,
    brandingConfigKey: PropTypes.string
  })
}

export default WealthOwnerInfoDisplay
